export enum StripeProduct
{
	ONE_CREDIT = "ONE_CREDIT",
	FIVE_CREDITS = "FIVE_CREDITS",
	TEN_CREDITS = "TEN_CREDITS",
	TWENTY_CREDITS = "TWENTY_CREDITS",
	FIFTY_CREDITS = "FIFTY_CREDITS",
	ONE_HUNDRED_CREDITS = "ONE_HUNDRED_CREDITS",
	TWO_HUNDRED_CREDITS = "TWO_HUNDRED_CREDITS"
}

export enum CreditPurchaseOption
{
	FIVE_CREDITS = "FIVE_CREDITS",
	TEN_CREDITS = "TEN_CREDITS",
	TWENTY_CREDITS = "TWENTY_CREDITS",
	FIFTY_CREDITS = "FIFTY_CREDITS",
}

export class CreditService
{
	public static getStripeProductFromPurchaseOption(option: CreditPurchaseOption): StripeProduct
	{
		switch(option)
		{
		case CreditPurchaseOption.FIVE_CREDITS:
			return StripeProduct.FIVE_CREDITS;
		case CreditPurchaseOption.TEN_CREDITS:
			return StripeProduct.TEN_CREDITS;
		case CreditPurchaseOption.TWENTY_CREDITS:
			return StripeProduct.TWENTY_CREDITS;
		case CreditPurchaseOption.FIFTY_CREDITS:
			return StripeProduct.FIFTY_CREDITS;
		default:
			return null;
		}
	}
}
